import { render } from "./ParentPayment.vue?vue&type=template&id=0f72d8df&scoped=true"
import script from "./ParentPayment.vue?vue&type=script&lang=js"
export * from "./ParentPayment.vue?vue&type=script&lang=js"

import "./ParentPayment.vue?vue&type=style&index=0&id=0f72d8df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f72d8df"]])

export default __exports__